import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TDevicesStore } from '@monorepo/types';

export const selectDevicesStore = createFeatureSelector<TDevicesStore>('DEVICES_STORE');
export const getPairedDeviceList = createSelector(selectDevicesStore, (initStore) => {
  return initStore.devicesDB.pairedDeviceInfo.list;
});

export const getConnectedDeviceInfo = createSelector(
  selectDevicesStore,
  (store) => store.devicesDB.connectedDeviceInfo,
);

export const getRfidScanMode = createSelector(
  selectDevicesStore,
  (store) => store.devicesDB.connectedDeviceInfo.scanMode,
);
